import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faStar, faSpinner } from '@fortawesome/free-solid-svg-icons';

const SellerInsight = ({
  product,
  isFollowing,
  checkingFollowStatus,
  followerCount,
  onToggleFollow,
  getDisplayName,
  navigate,
  isAuthenticated,
  user,
}) => {
  const isPremium = user?.isPremium || user?.premium_status === 'active';

  return (
    <motion.div
      className="pd-seller"
      initial={{ opacity: 0, x: 36 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.28, ease: [0.4, 0, 0.2, 1] }}
    >
      {/* Animated premium badge */}
      {product.seller_premium && (
        <div className="pd-seller__badge">
          <FontAwesomeIcon icon={faStar} />
          <span>Verified Premium Seller</span>
        </div>
      )}

      {/* Seller name */}
      <div
        className="pd-seller__name"
        onClick={() => product.seller_id && navigate(`/store/${product.seller_id}`)}
        style={{ cursor: product.seller_id ? 'pointer' : 'default' }}
        role={product.seller_id ? 'button' : undefined}
        tabIndex={product.seller_id ? 0 : undefined}
        onKeyDown={(e) => e.key === 'Enter' && product.seller_id && navigate(`/store/${product.seller_id}`)}
      >
        {getDisplayName(product.seller_name)}
      </div>

      <div className="pd-seller__meta">
        <span className="pd-seller__score">
          {product.seller_rating
            ? `${Math.round(product.seller_rating * 100)}% Score`
            : '98% Score'}
        </span>
        <span className="pd-seller__sep">·</span>
        <span className="pd-seller__followers">
          <FontAwesomeIcon icon={faUsers} />
          &nbsp;{followerCount.toLocaleString()}&nbsp;
          {followerCount === 1 ? 'Follower' : 'Followers'}
        </span>
      </div>

      {/* Action buttons */}
      <div className="pd-seller__actions">
        <button
          className={`pd-seller__follow-btn${isFollowing ? ' is-following' : ''}`}
          onClick={onToggleFollow}
          disabled={checkingFollowStatus}
        >
          {checkingFollowStatus ? (
            <>
              <FontAwesomeIcon icon={faSpinner} spin />
              &nbsp;{isFollowing ? 'Unfollowing…' : 'Following…'}
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faUsers} />
              &nbsp;{isFollowing ? 'Following' : 'Follow'}
            </>
          )}
        </button>

      </div>

      {/* Performance indicators */}
      <div className="pd-seller__indicators">
        <div className="pd-seller__indicator">
          <span className="pd-seller__dot" />
          <span>Shipping: {product.seller_shipping_speed || 'Excellent'}</span>
        </div>
        <div className="pd-seller__indicator">
          <span className="pd-seller__dot" />
          <span>Quality: {product.seller_quality || 'Excellent'}</span>
        </div>
        <div className="pd-seller__indicator">
          <span className="pd-seller__dot" />
          <span>Rating: {product.seller_customer_rating || 'Excellent'}</span>
        </div>
      </div>
    </motion.div>
  );
};

export default SellerInsight;
